import Badge from 'client/components/core/Badge'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { EntityProps } from 'client/types'
import CommonBodyNew from 'common/components/entities/BodyNew'
import { BlogPostContentPlaceholderInterface } from 'common/types/entities/BlogPostContentPlaceholderInterface'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import BlogPostContentPlaceholderUi from './ui/BlogPostContentPlaceholderUi'

function BlogPostContentPlaceholderNew({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BlogPostContentPlaceholderInterface>) {
  const { t } = useTypedTranslation()

  const renderChildren = () => {
    return entity.childIds.length > 0 ? (
      <ChildrenEntities
        id={entity.id}
        isReadOnly={entity.isReadOnly}
        childIds={entity.childIds}
        type={entity.type}
      />
    ) : (
      <>
        <BlogPostContentPlaceholderUi>
          {t('entities.blog_post_content_placeholder.placeholder')}
        </BlogPostContentPlaceholderUi>
        <Badge wide>
          {t('entities.blog_post_content_placeholder.warnings.do_not_remove')}
        </Badge>
      </>
    )
  }
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonBodyNew
        htmlAttrId={entity.htmlAttrId}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
      >
        {renderChildren()}
      </CommonBodyNew>
    </BaseEntityNew>
  )
}

export default BlogPostContentPlaceholderNew
